import { BadgeColor } from '@components/Badge';

import { OrderStatus, OrderType } from './common';

export const OrderStatusKr:Record<OrderStatus, string> = {
    NEW: '결제완료',
    PREPARING: '주문확인',
    READY: '제조완료',
    DONE: '픽업완료',
    CANCELLED: '주문취소',
    FAILED: '결제실패',
    UNKNOWN: '알수없음',
    NO_SHOW: '픽업기한 경과',
};

export const OrderStep: Record<OrderStatus, number> = {
    NEW: 0,
    PREPARING: 1,
    READY: 2,
    DONE: 3,
    CANCELLED: -1,
    FAILED: -1,
    UNKNOWN: -1,
    NO_SHOW: -1,
};

export const OrderTypeKr: Record<OrderType, string> = {
    IN_SHOP: '매장',
    TAKE_OUT: '포장',
};

export const OrderStatusBadgeColor: Record<OrderStatus, BadgeColor> = {
    NEW: 'blue',
    PREPARING: 'blue',
    READY: 'blue',
    DONE: 'gray',
    CANCELLED: 'red',
    FAILED: 'red',
    UNKNOWN: 'gray',
    NO_SHOW: 'red',
};
